/*=========================================================================================
  File Name: moduleApicilState.js
  Description: Apicil Module State.
              Used for the apicil subscription tunnel /src/views/Apicil
==========================================================================================*/
const state = {
  projectId: "",
  step: null,
  etatCivil: {
    civility: "",
    firstName: "",
    lastName: "",
    birthLastName: "",
    dateOfBirth: "",
    birthCity: "",
    birthState: "",
    birthDeptNum: "",
    birthCountry: "",
    nationality: "",
  },
  contactInfo: {
    address: "",
    addressComp: "",
    zipCode: "",
    city: "",
    country: "",
    email: "",
    mobileTel: "",
    homeTel: "",
    mobileTelFormatted: "",
    homeTelFormatted: "",
    homeTelIndicatif: "",
    mobileTelIndicatif: "",
  },
  residenceFiscale: {
    adresseFiscaleSame: true,
    isAmericanSubject: false,
    isForeignSubject: false,
    hasTin: false,
    nif: "",
    tin: "",
    nifCountry: "",
    contactInfo: {
      address: "",
      addressComp: "",
      zipCode: "",
      city: "",
      country: "",
    }
  },
  situationFamiliale: {
    famSituation: "",
    regimeMatrimonial: "",
    personneACharge: 0,
    hasConjoint: false,
    hasRegimeMatrimonial: false,
    conjointEtatCivil: {
      civility: "",
      firstName: "",
      lastName: "",
      birthLastName: "",
      dateOfBirth: "",
      birthCity: "",
      birthState: "",
      birthDeptNum: "",
      birthCountry: "",
      nationality: "",
    }
  },
  situationProfessionnelle: {
    proSituation: "",
    isNonSalarie: false,
    isPPE: false,
    isRelatedToPPE: false,
    proActuelle: "",
    companyName: "",
    socioProCat: "",
    activitySector: "",
    ppeFonction: "",
    ppeCountry: "1",
    ppeCountryVal: "",
    relatedPpeCountry: "1",
    relatedPpeCountryVal: "",
    ppeRelation: "",
    relatedPpeFonction: "",
    ppeLastName: "",
    ppeFirstName: "",
  },
  situationProfessionnelleConjoint: {
    proSituation: "",
    isNonSalarie: false,
    isPPE: false,
    isRelatedToPPE: false,
    proActuelle: "",
    companyName: "",
    socioProCat: "",
    activitySector: "",
    ppeFonction: "",
    ppeCountry: "1",
    ppeCountryVal: "",
    relatedPpeCountry: "1",
    relatedPpeCountryVal: "",
    ppeRelation: "",
    relatedPpeFonction: "",
    ppeLastName: "",
    ppeFirstName: "",
  },
  revenues: [],
  patrimoine: [],
  hasComments: false,
  userComments: "",
  isAdhesionVictoria: null,
  step1IsValid: false,
  step2IsValid: false,
  step3IsValid: false,
  step4IsValid: false,
  step5IsValid: false,
  selectedProduct: "",
  selectedModeGestion: "",
  selectedOrientationGestion: "",
  selectedSocieteGestion: 0,
  isSpecifique: false,
  isEpargneHandicap: false,
  isCoSouscriptionDemenbree: false,
  isSouscriptionMajeurSousTutelle: false,
  isPacteAdjointADonManuel: false,
  isSouscriptionMajeurSousCuratelle: false,
  isCoSouscription: false,
  isContratEnFondsPropres: false,
  isSignaturePapier: false,
  isSignatureElectronique: false,
  objectifInvest: "",
  dureeInvest: "",
  hasGarantiePlancher: false,
  dureeInvestVal: 0,
  hasVersementProgramme: false,
  VersementProgramme: {
    periodiciteVersement: "",
    montantVersement: 0
  },
  montantVersementInitial: 0,
  versementInitialMinimum: 0,
  resteAJustifie: 0,
  paymentFromSubscriber: true,
  payeurContactInfo: {
    firstName: "",
    lastName: "",
    lienParente: "",
    dateOfBirth: "",
    birthCity: "",
  },
  modePaiement: "",
  donneesBancaires: {
    titulaire: "",
    IBAN: "",
    BIC: ""
  },
  origineFonds: {
    transfertPlacement: 0,
    cessionActifsPro: 0,
    venteImmo: 0,
    venteBiensMobiliers: 0,
    successionOuDonation: 0,
    revenusPro: 0,
    autresOrigines: 0,
    commentaireAutres: ""
  },
  clauseBeneficiaire: "",
  notaireContactInfo: {
    firstName: "",
    lastName: "",
    zipCode: "",
    city: ""
  }
};

export default state;